// Parameter Interpolation API functions
import { getCachedApiUrl } from '../config/apiConfig';

export const performParameterInterpolation = async (projectId, requestData) => {
  try {
    const API_BASE_URL = await getCachedApiUrl();
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE_URL}/api/projects/${projectId}/parameter-interpolation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(requestData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to perform parameter interpolation');
    }

    return await response.json();
  } catch (error) {
    console.error('Error performing parameter interpolation:', error);
    throw error;
  }
};
